<sb-card>
  <div card-header>
    Setlist
    @if (_sharedSetlists?.length > 1) {
      {{ currentSetlist }}
    }
  </div>
  <div card-header-more class="unselectable">
    @if (_sharedSetlists?.length > 1) {
      <sb-icon (click)="e?.prev()" class="mx-1 cursor-pointer blue" icon="arrowLeftAlt"></sb-icon>
      {{ currentSetlist }} {{ 'lang.globals.of' | translate }} {{ _sharedSetlists?.length }}
      <sb-icon (click)="e?.next()" class="mx-1 cursor-pointer blue" icon="arrowRightAlt"></sb-icon>
    }
  </div>
  <div card-body>
    <ngb-carousel #e (slide)="currentSetlist = $event.current" [activeId]="currentSetlist" [interval]="-1" [keyboard]="false"
                  [showNavigationArrows]="false" [showNavigationIndicators]="false"
                  [wrap]="true">
      <ng-template *ngFor="let sharedSetlist of sharedSetlists; index as i" id="{{(i+1).toString(10)}}" ngbSlide>
        <div class="row">
          <div class="col-2">
            <h3>
              Info
            </h3>
            <div>
              <div class="d-flex flex-column justify-content-start">
                <div class="d-flex m-3">
                  <sb-icon class="mr-2" icon="stele" size="2x"></sb-icon>
                  <a>
                    {{ 'lang.globals.channel'|translate }}:
                    {{ sharedSetlist?.setlist?.marker?.channel?.name }}
                  </a>
                </div>
                <div class="d-flex m-3">
                  <sb-icon class="mr-2" icon="marker" size="2x"></sb-icon>
                  <a>
                    {{ 'lang.globals.marker'|translate }}:
                    {{ sharedSetlist?.setlist?.marker?.name }}
                  </a>
                </div>
                <div class="d-flex m-3">
                  <sb-icon class="mr-2" icon="resolution" size="2x"></sb-icon>
                  <a>
                    {{ 'lang.globals.resolution'|translate }}:
                    {{ sharedSetlist?.setlist?.marker?.resolution?.id }}
                  </a>
                </div>
                <div class="d-flex m-3">
                  <sb-icon class="mr-2" icon="bookings" size="2x"></sb-icon>
                  {{ 'lang.globals.bookings'|translate }}:
                  {{ sharedSetlist?.setlist?.bookingCount }}
                </div>
              </div>
            </div>
            <h3 class="mt-3">
              {{ 'lang.globals.validity' |translate }}
            </h3>
            <div>
              <div class="d-flex flex-column justify-content-start">
                <div class="d-flex m-3">
                  <a (click)="showScreensModal(sharedSetlist?.screens)">
                    <sb-icon class="mr-2" icon="screen" size="2x"></sb-icon>
                    {{ 'lang.globals.screens'|translate }}:
                    {{ sharedSetlist?.screens?.length }}
                  </a>
                </div>
                <div class="d-flex m-3">
                  <a (click)="showDateTimeRanges(sharedSetlist?.ranges)">
                    <sb-icon [icon]="'calendar'" class="mr-2" size="2x"></sb-icon>
                    {{ 'lang.globals.timeRanges'|translate }}:
                    {{ sharedSetlist?.ranges?.length }}
                  </a>
                </div>
              </div>
              <div class="d-flex mt-2 flex-column justify-content-start">
                <div *ngFor="let range of sharedSetlist?.ranges" class="d-flex my-1 mx-3 border-dashed-bottom"
                     [ngbTooltip]="util.calculateTimespanBetweenDates(range?.from, range?.till)" container="body"
                >
                  {{ util.dateToDateTimeString(range?.from?.value) }}  -  {{ util.dateToDateTimeString(range?.till?.value) }}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="currentSetlist === (i+1).toString()" class="col-9 offset-1">
            <h3>
              {{ 'lang.globals.customerSetlists' | translate }}
            </h3>
            <div>
              <sb-card *ngFor="let customerSetlist of sharedSetlist?.setlist?.customerSetlists" [collapsedCard]="true"
                       [isCollapsed]="false" [loadingDelay]="1">
                <div card-header>
                  {{ customerSetlist?.customer?.name }}
                </div>
                <div card-body>
                  <div class="row">
                    <div class="col-6">
                      <h5>
                        {{ 'lang.globals.staticBookings'|translate }}
                      </h5>
                      <ng-scrollbar style="height: 250px">
                        <div *ngFor="let booking of customerSetlist?.staticBookings" class="mb-2">
                          <sb-comp-image-name-wrapper [medium]="booking?.medium" [still]="true"
                                                      [hoverPreview]="true">
                            <span firstLine [innerHTML]="booking?.medium?.name"></span>
                            <span secondLine>
                                                        {{ 'lang.globals.commercial'|translate }}: {{ booking?.name }}
                                                    </span>
                            <span thirdLine
                                  *ngIf="booking?.templateDataSet"> {{ 'lang.globals.templateDataset'|translate }}:
                            <span
                              [innerHTML]="booking?.templateDataSet?.name | truncate:25">
                            </span>
                          </span>
                          </sb-comp-image-name-wrapper>
                        </div>
                      </ng-scrollbar>
                    </div>
                    <div class="col-6">
                      <h5>
                        {{ 'lang.globals.targetedBookings'|translate }}
                      </h5>
                      <ng-scrollbar style="height: 250px">
                        <table class="table">
                          <thead>
                          <tr>
                            <th>{{ 'lang.globals.level' |translate }}</th>
                            <th>{{ 'lang.globals.bookings' |translate }}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let leveledBooking of customerSetlist?.targetedBookings">
                            <td>{{ leveledBooking?.level }}</td>
                            <td>
                              <div *ngFor="let booking of leveledBooking?.bookings" class="mb-2">
                                <sb-comp-image-name-wrapper [medium]="booking?.medium" [still]="true"
                                                            [hoverPreview]="true">
                                  <span firstLine [innerHTML]="booking?.medium?.name"></span>
                                  <span secondLine>
                                                                    {{ 'lang.globals.commercial'|translate }}: {{ booking?.name }}
                                                                </span>
                                  <span thirdLine
                                        *ngIf="booking?.templateDataSet"> {{ 'lang.globals.templateDataset'|translate }}:
                            <span
                              [innerHTML]="booking?.templateDataSet?.name | truncate:25">
                            </span>
                          </span>
                                </sb-comp-image-name-wrapper>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </ng-scrollbar>
                    </div>
                  </div>
                </div>
              </sb-card>
              <!-- <ng-scrollbar [track]="'vertical'" style="height: 560px;">
                 <table class="table">
                   <thead>
                   <tr>
                     <th *ngIf="(discussionService.showRibbon|| discussionService.showDiscussionSideBar)"></th>
                     <th>
                       {{'lang.globals.booking' | translate}}
                     </th>
                     <th>
                       {{'lang.verification.advertiser' | translate}}
                     </th>
                     <th>
                       {{'lang.globals.medium' | translate}}
                     </th>
                     <th>
                       {{'lang.globals.medium.name' | translate}}
                     </th>
                     <th>
                       {{'lang.globals.publisher' | translate}}
                     </th>
                     <th>
                       {{'lang.globals.channel' | translate}}
                     </th>
                     <th>
                       {{'lang.globals.adSpace' | translate}}
                     </th>
                   </tr>
                   </thead>
                   <tbody>
                   <tr *ngFor="let booking of sharedSetlist.bookings; index as i; last as last">
                     <td *ngIf="(discussionService.showRibbon|| discussionService.showDiscussionSideBar)"
                         [entityElement]="{type: discussionService.DISCUSSABLES.Booking, element: booking, id: booking?.id}"
                         [inTable]="true"
                         [inline]="true" sb-discussion>
                     </td>
                     <td>{{i + 1}}
                       <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="booking?.id"
                                [dtoType]="tagService.TaggableDTO.Booking" [resolveInComponent]="true"></sb-tags>
                     </td>
                     <td>
                       <sb-comp-image-name-wrapper [image]="booking?.advertiser?.logo?.url">
                         <span [innerHTML]="booking?.advertiser?.name | truncate : 35" firstLine></span>
                       </sb-comp-image-name-wrapper>
                     </td>
                     <td>
                       <sb-comp-medium
                         [customHeight]="'100%'"
                         [customWidth]="'130px'" [medium]="booking?.medium" [showFullOnClick]="true"
                         [still]="true" [thumbnailSize]="'S'" [title]="true">
                       </sb-comp-medium>
                     <td>{{booking?.medium?.name}}</td>
                     <td>
                       <sb-comp-image-name-wrapper [image]="booking?.publisher?.logo?.url">
                         <span [innerHTML]="booking?.publisher?.name | truncate : 35" firstLine></span>
                       </sb-comp-image-name-wrapper>
                     </td>
                     <td>{{booking?.channel?.name}}</td>
                     <td>{{booking?.marker?.name}}</td>
                   </tr>
                   </tbody>
                 </table>
               </ng-scrollbar>
               -->
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
</sb-card>
